import React from 'react'
import Hero from './hero'
import Form from './form'

// Rebuilt on the new design system (Task 10). The old contact.css import is dropped - the
// page is rebuilt entirely on site.css's CONTACT banner (tokens, not the old fixed 1080px
// rules), same pattern Task 8 (services.css) and Task 9 (faqs.css) followed. The stylesheet
// itself is left in place, unreferenced - deleting a file outside src/css/site/ trips
// scripts/verify-scope.sh's known deletion bug (see Task 8's ledger ruling).
//
// Task 10 fix round 1: <Email/> is no longer rendered here as its own top-level section.
// Review flagged ~600px of dead white space below the form at 1440px, the first thing a
// visitor sees scrolling past the page's primary element. Form.jsx now renders <Email/>
// itself, stacked directly under the form inside the same grid column, so the mailto block
// fills that space with real (already-existing) content instead of leaving it empty - see
// form.jsx's own comment and task-10-report.md's fix-round section.
const Index = () => {
  return (
    <>
      <Hero/>
      <Form/>
    </>
  )
}

export default Index
